import React from "react";
import { motion } from "framer-motion";
import { ArrowRight, Loader2 } from "lucide-react";
import { useCheckout } from "@/lib/checkout";

export const FinalCta = () => {
  const { startCheckout, loadingPlan } = useCheckout();
  return (
    <section
      id="start"
      className="relative py-24 sm:py-32"
      data-testid="final-cta-section"
    >
      <div className="mx-auto max-w-5xl px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="relative overflow-hidden rounded-3xl border border-white/10 bg-gradient-to-b from-zinc-950 to-black p-10 sm:p-16 text-center"
        >
          <div
            aria-hidden
            className="absolute -top-32 left-1/2 -translate-x-1/2 h-[400px] w-[600px] rounded-full bg-blue-600/20 blur-[120px]"
          />
          <div
            aria-hidden
            className="absolute -bottom-32 -right-24 h-[300px] w-[300px] rounded-full bg-purple-600/20 blur-[120px]"
          />
          <div aria-hidden className="absolute inset-0 grid-bg opacity-50" />

          <div className="relative">
            <h2
              className="text-4xl sm:text-5xl lg:text-6xl font-semibold tracking-tighter text-white text-balance"
              data-testid="final-cta-headline"
            >
              Your Resume Should{" "}
              <span className="bg-gradient-to-r from-blue-300 via-indigo-200 to-purple-300 bg-clip-text text-transparent">
                Work For You
              </span>
            </h2>
            <p
              className="mt-5 max-w-xl mx-auto text-zinc-400 text-balance"
              data-testid="final-cta-subheadline"
            >
              Stand out from thousands of applicants with a modern AI-powered
              resume.
            </p>
            <div className="mt-9 flex flex-col sm:flex-row items-center justify-center gap-3">
              <button
                onClick={() => startCheckout("cv_pro")}
                disabled={loadingPlan === "cv_pro"}
                className="group inline-flex items-center gap-2 rounded-full bg-white text-black px-7 py-3 text-sm font-medium hover:bg-zinc-200 transition-colors disabled:opacity-60"
                data-testid="final-cta-start-now"
              >
                {loadingPlan === "cv_pro" ? (
                  <Loader2 className="h-4 w-4 animate-spin" />
                ) : null}
                Start Now
                <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5" />
              </button>
              <a
                href="#pricing"
                className="inline-flex items-center gap-2 rounded-full border border-white/15 bg-white/5 px-7 py-3 text-sm font-medium text-white hover:bg-white/10 transition-colors"
                data-testid="final-cta-see-pricing"
              >
                See pricing
              </a>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};
